'use strict';

exports.__esModule = true;
exports.loaderFromQueryOptions = exports.loadOneDoctorRecommendations = exports.loadPracticeDoctorsRecommendations = exports.loadPracticeDoctorsReviews = exports.loadProfileReviews = exports.QUERY_SPECIALISTS_PROFILE_TYPE = exports.QUERY_PRACTICES_PROFILE_TYPE = exports.DEFAULT_REVIEWS_OFFSET = exports.DEFAULT_REVIEWS_LIMIT = exports.tabsElements = exports.tabsArray = exports.DOCTORS_RECOMMENDATIONS_TAB = exports.DOCTORS_REVIEWS_TAB = exports.PRACTICE_REVIEWS_TAB = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _aboutPracticeTab = require('../components/about-practice-tab');

var _aboutPracticeTab2 = _interopRequireDefault(_aboutPracticeTab);

var _aboutDoctorsTab = require('../components/about-doctors-tab');

var _aboutDoctorsTab2 = _interopRequireDefault(_aboutDoctorsTab);

var _recommendationsTab = require('../components/recommendations-tab');

var _recommendationsTab2 = _interopRequireDefault(_recommendationsTab);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRACTICE_REVIEWS_TAB = exports.PRACTICE_REVIEWS_TAB = 'WF_PEER_RECOMMENDATION_PRACTICE_REVIEWS_TAB';
var DOCTORS_REVIEWS_TAB = exports.DOCTORS_REVIEWS_TAB = 'WF_PEER_RECOMMENDATION_DOCTORS_REVIEWS_TAB';
var DOCTORS_RECOMMENDATIONS_TAB = exports.DOCTORS_RECOMMENDATIONS_TAB = 'WF_PEER_RECOMMENDATION_DOCTORS_RECOMMENDATIONS_TAB';

var tabsArray = exports.tabsArray = [PRACTICE_REVIEWS_TAB, DOCTORS_REVIEWS_TAB, DOCTORS_RECOMMENDATIONS_TAB];

var tabsElements = exports.tabsElements = {
    'WF_PEER_RECOMMENDATION_PRACTICE_REVIEWS_TAB': {
        elem: _aboutPracticeTab2.default,
        title: { specialists: 'About Our Practice', practices: 'About Our Practice' }
    },
    'WF_PEER_RECOMMENDATION_DOCTORS_REVIEWS_TAB': {
        elem: _aboutDoctorsTab2.default,
        title: { specialists: 'Reviews', practices: 'About Our Doctors' }
    },
    'WF_PEER_RECOMMENDATION_DOCTORS_RECOMMENDATIONS_TAB': {
        elem: _recommendationsTab2.default,
        title: { specialists: 'Recommendations', practices: 'Our Recommendations' }
    }
};

var DEFAULT_REVIEWS_LIMIT = exports.DEFAULT_REVIEWS_LIMIT = 6;
var DEFAULT_REVIEWS_OFFSET = exports.DEFAULT_REVIEWS_OFFSET = 0;

var QUERY_PRACTICES_PROFILE_TYPE = exports.QUERY_PRACTICES_PROFILE_TYPE = 'practices';
var QUERY_SPECIALISTS_PROFILE_TYPE = exports.QUERY_SPECIALISTS_PROFILE_TYPE = 'specialists';

var loadProfileReviews = exports.loadProfileReviews = function loadProfileReviews(profileId, profileType, limit, offset, minReviewRating, dispatch, xhrConfig) {
    return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadReviewsStatForOne(profileId, profileType, xhrConfig)(dispatch), _widgetActions.widgetActions.loadReviewsForOne(profileId, profileType, limit, offset, minReviewRating, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    });
};

var loadPracticeDoctorsReviews = exports.loadPracticeDoctorsReviews = function loadPracticeDoctorsReviews(practiceId, limit, offset, minReviewRating, dispatch, xhrConfig) {
    return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadReviewsStatForAllDoctors(practiceId, xhrConfig)(dispatch), _widgetActions.widgetActions.loadReviewsForAllDoctors(practiceId, limit, offset, minReviewRating, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    });
};

var loadPracticeDoctorsRecommendations = exports.loadPracticeDoctorsRecommendations = function loadPracticeDoctorsRecommendations(practiceId, limit, offset, dispatch, xhrConfig) {
    return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadRecommendationsStatForAllDoctors(practiceId, xhrConfig)(dispatch), _widgetActions.widgetActions.loadRecommendationsForAllDoctors(practiceId, limit, offset, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    });
};

var loadOneDoctorRecommendations = exports.loadOneDoctorRecommendations = function loadOneDoctorRecommendations(specialistId, limit, offset, dispatch, xhrConfig) {
    return _promise2.default.all([dispatch(_widgetActions.widgetActions.changeOffset(offset)), _widgetActions.widgetActions.loadRecommendationsForOneDoctor(specialistId, limit, offset, xhrConfig)(dispatch)]).catch(function (error) {
        console.log(error);
    });
};

var loaderFromQueryOptions = exports.loaderFromQueryOptions = function loaderFromQueryOptions(profileId, profileType, activeTab, limit, offset, minReviewRating, dispatch, xhrConfig) {
    switch (activeTab) {
        case PRACTICE_REVIEWS_TAB:
        default:
            return loadProfileReviews(profileId, profileType, limit, offset, minReviewRating, dispatch, xhrConfig);
        case DOCTORS_REVIEWS_TAB:
            switch (profileType) {
                case QUERY_PRACTICES_PROFILE_TYPE:
                default:
                    return loadPracticeDoctorsReviews(profileId, limit, offset, minReviewRating, dispatch, xhrConfig);
                case QUERY_SPECIALISTS_PROFILE_TYPE:
                    return loadProfileReviews(profileId, profileType, limit, offset, minReviewRating, dispatch, xhrConfig);
            }
        case DOCTORS_RECOMMENDATIONS_TAB:
            switch (profileType) {
                case QUERY_PRACTICES_PROFILE_TYPE:
                default:
                    return loadPracticeDoctorsRecommendations(profileId, limit, offset, dispatch, xhrConfig);
                case QUERY_SPECIALISTS_PROFILE_TYPE:
                    return loadOneDoctorRecommendations(profileId, limit, offset, dispatch, xhrConfig);
            }
    }
};